import { CONFIG, SELECTOR } from "./config.es6";

export default class Share {
    constructor(root) {
        this.root = root;
    }

    handleShareClick(event) {
        const target = event.currentTarget;
        const url = target.getAttribute("href");
        if (!url || url === "#") return;

        event.preventDefault();
        window.open(url, "_blank", "noopener,noreferrer");
    }

    createShareText(isSuccess, elapsedSeconds, matchedPairs) {
        const successTemplate = this.root.dataset.shareSuccess
            || "『ツガイ神経衰弱』全{total}組を{time}で揃えました！";
        const failureTemplate = this.root.dataset.shareFailure
            || "『ツガイ神経衰弱』に挑戦して{matched}組揃えました！";
        const template = isSuccess ? successTemplate : failureTemplate;

        return `${template
            .split("{total}").join(String(CONFIG.totalPairs))
            .split("{matched}").join(String(matchedPairs))
            .split("{time}").join(this.formatJapaneseTime(elapsedSeconds))} ${CONFIG.shareHashtags}`;
    }

    updateShareLinks(shareText) {
        const pageUrl = CONFIG.shareUrl;
        this.root.querySelectorAll(SELECTOR.share).forEach((link) => {
            const service = link.dataset.shareService || "x";
            let shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(pageUrl)}`;
            if (service === "line") {
                shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(shareText)}`;
            } else if (service === "facebook") {
                shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
            }
            link.setAttribute("href", shareUrl);
        });
    }

    formatJapaneseTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const rest = Math.floor(seconds % 60);
        return `${minutes > 0 ? `${minutes}分` : ""}${rest}秒`;
    }
}
